module.exports = __webpack_public_path__ + "static/common-ar-mobile-1c2150da95418955cc39107669846b3c.png";